exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-height: 740px) {\n.register-box {\n    padding: 1.9rem 1.25rem !important;\n    margin-bottom: 0 !important;\n}\n}\n.checkbox {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  padding-left: 30px;\n}\n.pt-30 {\n  padding-top: 7rem;\n}\n.max-h-100 {\n  max-height: 420px;\n}", ""]);

// exports
